// Quick-view media gallery thumbnail fix
// Works regardless of when/how the quick-view HTML is injected into the DOM,
// because it delegates from `document` instead of binding listeners to
// individual thumbnail buttons at init time.

document.addEventListener('click', function (event) {
  // Was a thumbnail button (or something inside it) clicked?
  const button = event.target.closest('.thumbnail-list__item button, [data-target] button');
  if (!button) return;

  // The <li> that carries data-target="{{ section.id }}-{{ media.id }}"
  const thumbLi = button.closest('[data-target]');
  if (!thumbLi) return;

  const mediaId = thumbLi.dataset.target;
  if (!mediaId) return;

  // Scope to the correct gallery instance (handles quick-view + main page
  // both being present on the page at once without id collisions), by
  // walking up to the nearest <media-gallery> ancestor.
  const galleryRoot = button.closest('media-gallery');
  if (!galleryRoot) return;

  // The featured/viewer <li> elements carry data-media-id="{{ section.id }}-{{ media.id }}"
  const targetSlide = galleryRoot.querySelector(`[data-media-id="${mediaId}"]`);
  if (!targetSlide) return;

  // Swap the active slide
  galleryRoot.querySelectorAll('[data-media-id]').forEach(function (slide) {
    slide.classList.remove('is-active');
  });
  targetSlide.classList.add('is-active');

  // Scroll the viewer list so the newly active slide is in view
  const viewerList = targetSlide.parentElement;
  if (viewerList && typeof viewerList.scrollTo === 'function') {
    viewerList.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
  }

  // Update aria-current + active thumbnail state
  const thumbsContainer = thumbLi.closest('ul, [id^="GalleryThumbnails"]');
  if (thumbsContainer) {
    thumbsContainer.querySelectorAll('button').forEach(function (b) {
      b.removeAttribute('aria-current');
    });
  }
  button.setAttribute('aria-current', 'true');
});